import amplitude from 'amplitude-js/amplitude';
import AppConfig from 'utils/app-config';

class AmplitudeService {
  constructor() {
    this.amplitude = amplitude.getInstance();
  }

  initialize(apiKey, eventContext = {}) {
    this.amplitude.init(apiKey);
    this.context = eventContext;
  }

  logEvent(eventName, properties, callback) {
    const eventNameWithPrefix = `[qp] ${eventName}`;
    const eventProperties = { ...this.context, ...properties };

    if (AppConfig.get('environment') === 'production') {
      return this.amplitude.logEvent(eventNameWithPrefix, eventProperties, callback);
    }

    if (AppConfig.get('environment') === 'development' && window.console) {
      /* eslint no-console: ["error", { allow: ["info"] }] */
      console.info(
        `Event "${eventNameWithPrefix}" will be tracked by Amplitude with the following params:`,
        eventProperties,
      );
    }

    if (callback !== null) {
      return setTimeout(callback, 100);
    }
    return true;
  }
}

export default new AmplitudeService();
